function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "home_outline_28"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1295491,2.69100093 L24.0662484,11.1808652 C24.6624397,11.747247 25,12.53353 25,13.3558635 L25,21.9972407 C25,23.3779526 23.8807119,24.4972407 22.5,24.4972407 L16.5,24.4972407 C15.9477153,24.4972407 15.5,24.0495254 15.5,23.4972407 L15.5,17.9971013 C15.5,17.1686742 14.8284271,16.4971013 14,16.4971013 C13.1715729,16.4971013 12.5,17.1686742 12.5,17.9971013 L12.5,23.4972407 C12.5,24.0495254 12.0522847,24.4972407 11.5,24.4972407 L5.5,24.4972407 C4.11928813,24.4972407 3,23.3779526 3,21.9972407 L3,13.3558635 C3,12.53353 3.33756025,11.747247 3.93375161,11.1808652 L12.8704509,2.69100093 C13.5034346,2.08966636 14.4965654,2.08966636 15.1295491,2.69100093 Z M14,4.37655211 L5.31125054,12.6308641 C5.11252008,12.819658 5,13.0817523 5,13.3558635 L5,21.9972407 C5,22.2733831 5.22385763,22.4972407 5.5,22.4972407 L10.5,22.4972407 L10.5,17.9971013 C10.5,16.0641047 12.0670034,14.4971013 14,14.4971013 C15.9329966,14.4971013 17.5,16.0641047 17.5,17.9971013 L17.5,22.4972407 L22.5,22.4972407 C22.7761424,22.4972407 23,22.2733831 23,21.9972407 L23,13.3558635 C23,13.0817523 22.8874799,12.819658 22.6887495,12.6308641 L14,4.37655211 Z",
  id: "\\u21B3-Icon-Color",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.1eae9d63.svg";
export { ForwardRef as ReactComponent };